/**
 * Convert Fahrenheit to Celsius
 * @param {Number} temp
 */
export function fahrenheitToCelsius(temp) {
	if (isNaN(parseFloat(temp)) && !isFinite(temp)) {
		return temp;
	}

	return Math.round((temp - 32) * 5 / 9);
}

/**
 * Converts 24-hour time to 12-hour time
 */
export function nonMilitaryTime(hour) {
	if (hour > 12) {
		hour -= 12;
	}
	else if (hour === 0) {
		hour = 12;
	}
	return hour;
}

/**
 * Remove '/' slashes from string and replace with ', ' comma + space
 * @param {String} str  String to replace slashes in
 */
export function replaceFwdSlash(str) {
	return str.replace(/\//g, ', ');
}

/**
 * Format a date object to a hh:mm string.
 * Sample date object value: 2017-02-10T17:32:51-0800
 */
export function handleSunFormat(d) {
	if (d) {
		let a = d.replace(/\D/g, ' ').split(' ');
		let hour = nonMilitaryTime(~~a[3]);
		let minute = a[4];
		if (minute.toString().length === 1) {
			minute = '0' + minute;
		}
		return `${hour}:${minute}`;
	}
}

/**
 * Appends utm_* style tracking parameters to a URL
 * @param  {string}                	originalUrl
 * @param  {Object<string, string>}	trackingParams
 * @returns {string}
 */
export function appendTrackingParameters(originalUrl, trackingParams) {
	const parsedUrl = new URL(originalUrl);
	Object.entries(trackingParams).forEach(([name, value]) => parsedUrl.searchParams.append(name, value));
	return parsedUrl.toString();
}
